export const extractIds = list => list.map(({ id }) => id);
